import { useMemo } from "react";
import { URLSearchParamsInit, useSearchParams } from "react-router-dom";
import { cleanObject } from "utils";

// <K extends string> 泛型约束
export const useUrlQueryParam = <K extends string>(keys: K[]) => {
  const [searchParam] = useSearchParams();
  const setUrlSearchParam = useSetUrlSearchParam();

  return [
    useMemo(
      () =>
        keys.reduce((prev, key) => {
          return { ...prev, [key]: searchParam.get(key) || "" };
        }, {} as { [key in K]: string }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [searchParam]
    ),
    // setSearchParam,
    (params: Partial<{ [key in K]: unknown }>) => {
      return setUrlSearchParam(params);
    },
  ] as const;
};

// as type 类型断言
// 推断为数组类型，元素为 string 或者 number
// const foo = ["hello", 101];
// 推断为数组类型，只能有两个元素，第一个是 string 类型，第二个是 number 类型
// const bar = ["hello", 101] as const;

export const useSetUrlSearchParam = () => {
  const [searchParam, setSearchParam] = useSearchParams();

  return (params: { [key in string]: unknown }) => {
    const o = cleanObject({
      ...Object.fromEntries(searchParam),
      ...params,
    }) as URLSearchParamsInit;
    return setSearchParam(o);
  };
};
